import React from 'react';
import Button from '@mui/material/Button'

import './Button.css'

function CustomButton({text,icon}) {
  return (
    <div className="btn-box">
      <Button className="custom-btn">
       <span> {text}</span>
        <span className="btn-icon">
        {
          icon ? icon : ''
        }
        </span>
      </Button>
    </div>
  );
}

export default CustomButton;